import { JOB_ORDER, getJob, type JobId } from '../data/jobs';
import { ROSTER } from '../data/titles';
import { focusAfterKey } from './focusAfterKey';

type Ok = (name: string, jobId: JobId) => void;

export class CreateOverlay {
  static blocking = false;

  private static onOk: Ok | null = null;
  private static jobId: JobId = JOB_ORDER[0] ?? 'warrior';

  static show(onOk: Ok): void {
    this.onOk = onOk;
    this.blocking = true;
    this.jobId = JOB_ORDER[0] ?? 'warrior';
    const dock = document.getElementById('char-dock');
    if (dock) dock.hidden = false;
    const err = document.getElementById('char-error');
    if (err) err.textContent = '';
    const name = document.getElementById('char-name') as HTMLInputElement | null;
    if (name) {
      name.maxLength = ROSTER.nameMax;
      name.value = '';
      focusAfterKey(name);
    }
    this.paintJobs();
  }

  static hide(): void {
    this.blocking = false;
    this.onOk = null;
    const dock = document.getElementById('char-dock');
    if (dock) dock.hidden = true;
  }

  static error(message: string): void {
    const err = document.getElementById('char-error');
    if (err) err.textContent = message;
  }

  static bind(): void {
    const make = document.getElementById('char-make');
    const cancel = document.getElementById('char-cancel');
    make?.addEventListener('click', () => this.submit());
    cancel?.addEventListener('click', () => this.hide());
    document.getElementById('char-name')?.addEventListener('keydown', (ev) => {
      ev.stopPropagation();
      if ((ev as KeyboardEvent).key === 'Enter') {
        ev.preventDefault();
        this.submit();
      }
      if ((ev as KeyboardEvent).key === 'Escape') {
        ev.preventDefault();
        this.hide();
      }
    });
    document.getElementById('char-form')?.addEventListener('submit', (ev) => ev.preventDefault());
    document.getElementById('char-jobs')?.addEventListener('click', (ev) => {
      const btn = (ev.target as HTMLElement | null)?.closest('button[data-job]') as HTMLButtonElement | null;
      if (!btn?.dataset.job) return;
      this.jobId = btn.dataset.job as JobId;
      this.paintJobs();
    });
    this.paintJobs();
  }

  private static paintJobs(): void {
    const host = document.getElementById('char-jobs');
    if (!host) return;
    host.innerHTML = '';
    for (const id of JOB_ORDER) {
      const job = getJob(id);
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.dataset.job = id;
      btn.textContent = job.name;
      btn.className = this.jobId === id ? 'job-pick is-on' : 'job-pick';
      host.appendChild(btn);
    }
  }

  private static submit(): void {
    const name = (document.getElementById('char-name') as HTMLInputElement | null)?.value.trim() ?? '';
    if (name.length < ROSTER.nameMin || name.length > ROSTER.nameMax) {
      this.error(`이름은 ${ROSTER.nameMin}~${ROSTER.nameMax}자`);
      return;
    }
    const cb = this.onOk;
    if (!cb) return;
    cb(name, this.jobId);
  }
}
